import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AutoLotView } from 'src/app/const';

import {
  Bid,
  BidStatusEnum,
  LotStatusEnum,
  UserLotQuery,
} from '../../graphql/service/graphql-auto-main-service';
import { BidLeaderStatus } from './enum/bid-leader-status.enum';

@Component({
  selector: 'app-bid-leader-status',
  templateUrl: './bid-leader-status.component.html',
  styleUrls: ['./bid-leader-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BidLeaderStatusComponent {
  @Input() lot: AutoLotView | Bid['lot'];
  @Input() bid: UserLotQuery['lot']['currentUserLastBid'] | Bid;

  BidLeaderStatus = BidLeaderStatus;

  get leaderStatus(): BidLeaderStatus | null {
    if (!this.bid || !this.lot) {
      return null;
    } else if (this.auctionEnd) {
      return this.bid.status === BidStatusEnum.Won
        ? BidLeaderStatus.LeaderAuctionEnd
        : BidLeaderStatus.NotLeaderAuctionEnd;
    } else if (this.lot.status === LotStatusEnum.Negotiations) {
      return BidLeaderStatus.Negotiations;
    } else if (this.bid.status === BidStatusEnum.Initial && this.bid.wasOverbid === false) {
      return BidLeaderStatus.BestBid;
    } else if (this.bid.nowBest && this.bid.wasOverbid) {
      return BidLeaderStatus.LeaderRisky;
    } else if (this.bid.nowBest) {
      return BidLeaderStatus.Leader;
    } else {
      return BidLeaderStatus.NotLeader;
    }
  }

  private get auctionEnd(): boolean {
    return [
      LotStatusEnum.Sold,
      LotStatusEnum.Unsold,
      LotStatusEnum.Won,
      LotStatusEnum.NegotiationSold,
    ].includes(this.lot.status as LotStatusEnum);
  }
}
